<template>
	<div>
		<div v-if="saved">
			<div class="row">
				<div class="col-12 mb-4">
					<div
						class="card"
						style="width: 18rem; margin: 40px auto 0"
						data-cy="test-saved"
					>
						<div class="card-body text-center">
							<b-icon
								icon="check-circle-fill"
								class="text-success mb-2"
								style="font-size: 1.5rem"
							/>
							<h5 class="card-title">{{ $t("test-saved") }}</h5>
							<p class="card-text">
								{{ $t("test-saved-successfully") }}
							</p>
							<router-link to="/tests">
								<button class="btn btn-primary">{{ $t("done") }}</button>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="error">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon
								icon="x-circle-fill"
								class="text-danger mb-2"
								style="font-size: 1.5rem"
							/>
							<h5 class="card-title capitalise">{{ $t("error") }}</h5>
							<p class="card-text">
								{{ $t("problem-saving-test") }}
							</p>
							<button class="btn btn-primary" @click="saveTest">
								<b-icon icon="arrow-clockwise" />
								{{ $t("try-again") }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else-if="selectedUser && selectedTest && !this.saved && !this.error">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="float-sm-left">
						<h1 class="mb-0">
							{{ selectedTest.Code }}:
							{{ selectedTest.Name }}
						</h1>
						<p class="mb-0">
							<b-icon icon="person" class="mr-1" />
							{{ isTeacher ? selectedTest.student_displayname :  selectedTest.teacher_displayname }}
						</p>
						<p class="mb-0">
							<b-icon icon="clock" class="mr-1" />
							{{ $datetime.getLocaleStringFromTimeStamp( selectedTest.DateAdded) }}
						</p>
					</div>

					<button
						class="btn btn-primary float-right"
						data-cy="save-test"
						@click="saveTest"
					>
						{{ $t("save-test") }}
					</button>
				</div>
			</div>
            
			<TestMarkingForm
				:test="selectedTest"
				:readonly="!canEdit"
                :submittercanedittheirfields="submittercanedittheirfields"
                :custompassfail="custompassfail"
			>
			</TestMarkingForm>

		</div>

		<div v-else-if="!this.saved && !this.error">
			<div class="row">
				<div class="col-12 mb-4">
					<h1 class="float-sm-left">{{ $t("select-test") }}</h1>

					<div class="form-inline float-sm-right">
						<input
							type="search"
							class="form-control"
							placeholder="Search tests..."
							v-model="searchTerm"
							@keyup="searchTests"
						/>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12 mb-4">
					<div class="list-group" v-if="loadingTests">
						<div class="list-group-item" v-for="index in 10" :key="index">
							<div class="skeleton midnight h20 w200 mb-3"></div>
							<div class="skeleton midnight h20 w50"></div>
						</div>
					</div>

					<div class="card" style="width: 18rem; margin: 40px auto 0" v-if="error">
						<div class="card-body text-center">
							<b-icon
								icon="x-circle-fill"
								class="text-danger mb-2"
								style="font-size: 1.5rem"
							/>
							<h5 class="card-title">{{ $t("error") }}</h5>
							<p class="card-text">
								{{ $t("problem-loading-tests") }}
							</p>
							<button class="btn btn-primary" @click="loadTests">{{ $t('load-tests') }}</button>
						</div>
					</div>

					<div class="form-row mb-2">

						<!--
						<button
						class="btn mr-2"
						:class="{'btn-primary': programmeyear.active, 'btn-secondary': !programmeyear.active}"
						v-for="programmeyear in programmeyears"
						:key="`${programmeyear.programme}-${programmeyear.year}`"
						@click="programmeyear.active = !programmeyear.active"
						>
						{{ programmeyear.title }}
						</button>

						<button
						class="btn mr-2"
						:class="{'btn-primary': filter.active, 'btn-secondary': !filter.active}"
						v-for="filter in filters"
						:key="filter.competencytestfilter_id"
						@click="filter.active = !filter.active"
						>
						{{ filter.competencytestfilter_caption }}
						</button>-->

						<div class="col">
							<div class="form-group">
								<label>Programme/year</label>
								<select class="form-control" v-model="selectedProgrammeyear">
									<option :value="null">{{ $t("any") }}</option>
									<option
									v-for="programmeyear in programmeyears"
									:key="`${programmeyear.programme}-${programmeyear.year}`"
									:value="`${programmeyear.programme}-${programmeyear.year}`"
									>{{ programmeyear.title }}
									</option>
								</select>
							</div>
						</div>
						<div class="col">
							<div class="form-group">
								<label>Category</label>
								<select class="form-control" v-model="selectedCategory">
									<option :value="null">{{ $t("any") }}</option>
									<option
									v-for="filter in filters"
									:key="filter.competencytestfilter_id"
									:value="filter.competencytestfilter_id"
									>{{ filter.competencytestfilter_caption }}
									</option>
								</select>
							</div>
						</div>


					</div>

					<div class="list-group" v-if="tests.length">
						<div
							:class="
								selectedTest && test.id === selectedTest.id
									? 'list-group-item active'
									: 'list-group-item'
							"
							v-for="(test, index) in filteredResults"
							:key="test.id"
							:data-cy="`test-type-${index}`"
							@click="selectTest(test)"
						>
							<p class="mb-1 mt-1 font-bold">{{ test.Code }}: {{ test.Name }}</p>
							<p class="mb-1">{{ test.Description }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TestMarkingForm from "src/components/TestMarkingForm.vue";
export default {
	components: {
		TestMarkingForm
	},
	data: function() {
		return {
			loadingTests: false,
			error: null,
			saved: false,
			tests: [],
			selectedTest: null,
			selectedUser: null,
			searchTerm: "",
			results: [],
			treatmentsession: {
				isLocked: false
			},
			formresponse: null,
			pageNum: 1,
			filters: [],
			programmeyears: [],
			user: null,
			selectedProgrammeyear: null,
			selectedCategory: null,
            submittercanedittheirfields: false,
            custompassfail : []
		};
	},
	mounted: function() {
		this.$users.getUserById.call(this, this.$UserSession.getValue('id')).then(user => {
			this.user = user;
			this.loadTests()
		});
	},
	methods: {
		getProgrammeNameById(id) {
			for (let programme of Object.values(this.$config.getValue('programmes'))) {
				if(programme.Id == id) {
					return programme.Name;
				}
			}
		},
		haveProgrammeyear(programme, year) {
			for(let programmeyear of this.programmeyears) {
				if(programmeyear.programme == programme && programmeyear.year == year) {
					return true;
				}
			}
			return false;
		},
		setProgrammeyears() {
			this.programmeyears = [];
			let active;
			for(let test of this.tests) {
				for(let [programme, years] of Object.entries(test.programmeyears)) {
					for(let year of years) {
						if(!this.haveProgrammeyear(programme, year)) {
							if(this.user){
								active = this.user.isStudent && (this.user.programme == programme) && (this.user.year == year);
								if(active) {
									this.selectedProgrammeyear = `${programme}-${year}`;
								}
							}
							this.programmeyears.push({
								programme,
								year,
								title: `Year ${year} ${this.getProgrammeNameById(programme)}`,
								active
							})
						}
					}
				}
			}
		},
		setFilters(filters) {
			this.filters = [];
			for(let filter of filters) {
				filter.active = false;
				this.filters.push(filter);
			}
		},
		loadTests: function() {
			this.error = null;
			this.loadingTests = true;

			this.$cfetch(`${this.$settings.APIBaseURL}/treatmentsessions/listcompetencytests`, {
				method: "post"
			})
				.then(res => {
					if (res.status === "SUCCESS") {
						this.tests = res.competencyTests;
						this.results = res.competencyTests;
						this.loadingTests = false;
						this.setFilters(res.filters);
						this.setProgrammeyears();

						if (this.$route.params.testId) {
							const selectedTest = this.tests.filter(el => el.id == this.$route.params.testId);
							if(selectedTest[0]){
								this.selectTest(selectedTest[0]);
							} else {
								this.error = true;
							}
						}

					} else {
						this.error = true;
					}
				})
				.catch(err => {
					this.error = err;
					this.loadingTests = false;
				});
		},
		selectTest: function(test) {
			var selectedTest = JSON.parse(JSON.stringify(test));
			selectedTest.HasPassed = -1;
			selectedTest.teacher_id = null;
			selectedTest.teacher_displayname = null;
			selectedTest.student_id = null;
			selectedTest.student_displayname = null;
			selectedTest.HasPassed = -1;

			selectedTest.DateAdded = Math.round(new Date().getTime() / 1000);

			if (this.isTeacher) {
				selectedTest.teacher_id = this.$UserSession.getValue("id");
				selectedTest.teacher_displayname = this.$UserSession.getValue(
					"displayName"
				);
			} else {
				selectedTest.student_id = this.$UserSession.getValue("id");
				selectedTest.student_displayname = this.$UserSession.getValue(
					"displayName"
				);
			}

			this.tryGetForm(selectedTest);

			this.selectedTest = selectedTest;

			if (!this.selectedUser) {
				this.openUserSelect();
			}
		},
		tryGetForm(competencyTest) {
			if (competencyTest.form_id && !competencyTest.form) {
				this.$cfetch
					.call(
						this,
						`${this.$settings.APIBaseURL}/forms/getform/${competencyTest.form_id}`,
						{
							method: "post",
							cache: true,
							data: {
                                competencytestform: true
                            },
						}
					)
					.then((res) => {
						if (res.status == "SUCCESS") {
							competencyTest.form = res.form.settings;
                            this.submittercanedittheirfields = res.form.submittercanedittheirfields;
                            this.custompassfail = res.custompassfail;

						} else {
							this.$log.error.call(this, "Could not fetch form");
						}
					})
					.catch((error) => {
						this.$log.error.call(this, error);
					});
			}
		},
		openUserSelect: function() {
			if (this.isTeacher) {
				this.$users.getStudents.call(this).then(students => {
					this.openSelector(students);
				});
			} else {
				this.$users.getTeachers.call(this).then(teachers => {
					this.openSelector(teachers);
				});
			}
		},
		openSelector: function(results) {
			const self = this;
			this.$store.commit("openModal", {
				type: "selector",
				title: this.isTeacher ? this.$t("select-a-student") : this.$t("select-a-teacher"),
				selectCallback: function(selection) {
					self.selectedUser = selection;
					if(self.isTeacher){
						self.selectedTest.student_id = selection.id;
						self.selectedTest.student_displayname =  selection.displayName;
					} else {
						self.selectedTest.teacher_id = selection.id;
						self.selectedTest.teacher_displayname =  selection.displayName;
					}
					self.$store.commit("closeModal");
				},
				selected: [
					{
						id: self.selectedUser && self.selectedUser.id
					}
				],
				data: results,
				captionKey: "displayName",
                subcaptionKey: "studentid",
				studentSearchFilters: this.isTeacher
			});
		},
		saveTest: function() {
			// api call here
			// this.saved = true;

			var competencytestsession = {
				CompetencyTestID: this.selectedTest.id,
				student_id: this.selectedTest.student_id,
				teacher_id: this.selectedTest.teacher_id,
				form: null,
				HasPassed: this.selectedTest.HasPassed
			};

			if('form' in this.selectedTest){
				competencytestsession.form = this.selectedTest.form
			}

			this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/session/save`, {
				method: "post",
				data: {
					competencytestsession: competencytestsession
				}
			})
				.then(res => {
					if (res.status === "SUCCESS") {
						this.saved = true;
					} else {
						this.error = true;
					}
				})
				.catch(err => {
					this.error = err;
				});
		},
		reselectTest: function() {
			this.selectedTest = null;
		},
		searchTests: function() {
			const words = this.searchTerm.split(" ");

			if (this.searchTerm !== "" && words.length) {
				const transformWords = arr => {
					const ignoreWords = ["a", "to", "and", "this", "the", "in", "for", " ", "-"];

					return arr
						.filter(word => {
							return ignoreWords.indexOf(word) === -1;
						})
						.map(word => word.toLowerCase());
				};

				const results = this.tests.filter(result => {
					const resultWords = [
						...transformWords(result.Name.split(" ")),
						...transformWords(result.Description.split(" "))
					];

					const isMatched = words.reduce((prev, curr) => {
						if (prev === true) {
							return true;
						}
						if (resultWords.indexOf(curr) >= 0) {
							return true;
						}
						return false;
					}, false);

					if (isMatched) {
						return result;
					}
				}, []);

				this.results = results;
			} else {
				this.results = [...this.tests];
			}
		},
		markCompetencyTest() {
			//console.log("mark test");
		},
		togglePassed(pass) {
			//console.log("toggle pass", pass);
			this.selectedTest.HasPassed = pass;
		}
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
		canEdit: function() {
			if(this.isTeacher){
				return true;
			}
			if(this.test && 'form' in this.test && this.test.form && this.test.HasPassed === -1){
				return true;
			}
			return false;
		},
		activeProgrammeYears() {
			const arr = [];
			for(let programmeyear of this.programmeyears) {
				if(programmeyear.active) {
					arr.push(programmeyear);
				}
			}
			return arr;
		},
		activeFilterIds() {
			const arr = [];
			for(let filter of this.filters) {
				if(filter.active) {
					arr.push(filter.competencytestfilter_id);
				}
			}
			return arr;
		},
		filteredResults() {

			/*if(!this.activeProgrammeYears.length && !this.activeFilterIds.length) {
				return this.results;
			}*/

			if(!this.selectedProgrammeyear && !this.selectedCategory) {
				return this.results;
			}

			// make a copy
			let results = JSON.parse(JSON.stringify(this.results));

			/*const activeProgrammeYears = this.activeProgrammeYears;
			const activeFilterIds = this.activeFilterIds;*/

			const selectedProgrammeyear = this.selectedProgrammeyear;
			const selectedCategory = this.selectedCategory;

			let selectedProgramme, selectedYear;
			if(selectedProgrammeyear) {
				[selectedProgramme, selectedYear] = selectedProgrammeyear.split('-')
			}

			return results.filter(function(result) {

				/*for(let programmeyear of activeProgrammeYears) {
					if(
						!Object.hasOwnProperty.call(result.programmeyears, programmeyear.programme)
						|| !result.programmeyears[programmeyear.programme].includes(programmeyear.year)
					) {
						return false;
					}
				}

				for(let filterId of activeFilterIds) {
					if(!result.Filters.includes(filterId)) {
						return false;
					}
				}*/

				if(
					selectedProgrammeyear &&
					(!Object.hasOwnProperty.call(result.programmeyears, selectedProgramme)
					|| !result.programmeyears[selectedProgramme].includes(selectedYear))
				) {
					return false;
				}

				if(selectedCategory && !result.Filters.includes(selectedCategory)) {
					return false;
				}


				return true;

			});

		}
	}
};
</script>
